import React from 'react';
import { Alert as AntAlert } from 'antd';

/**
 * Wrapper component for Ant Design Alert
 *
 * This wrapper allows us to easily replace Ant Design in the future without changing all imports.
 * It preserves all Ant Design Alert functionality including types, closable, and icon options.
 *
 * @component
 * @example
 * import { Alert } from '../GeneralComponents/ui';
 *
 * <Alert message="Success Text" type="success" />
 * <Alert message="Info Text" type="info" />
 * <Alert message="Warning Text" type="warning" />
 * <Alert message="Error Text" type="error" />
 * <Alert message="Closable Alert" type="info" closable onClose={onClose} />
 *
 * @see https://ant.design/components/alert/ - Ant Design Alert documentation
 */
const Alert = (props) => {
  return <AntAlert {...props} icon={props.iconType} style={{ borderRadius: '8px', opacity: 0.5, ...props.style }} />;
};

export default Alert;
